import React from "react";
import FilterBar from "components/FilterBar";
import DSBox from "../../system-design/DSBox";
import CountryDropdown from "./CountryDropdown";
import StateDropdown from "./StateDropdown";
import LoadKlydosButton from "./LoadKlydosButton";
import { KlydoError } from "../../../components/hooks/types";
import { GeographicRegion, State } from "../../../api/calendarEvent";

type CalendarControlsProps = {
  country: GeographicRegion | null;
  state?: State | null;
  onCountryChange: (country: GeographicRegion | null) => void;
  onStateChange: (state: State | null) => void;
  onLoadKlydos: () => void;
  klydosLoading: boolean;
  klydosError: KlydoError | null;
  klydosLoaded: boolean;
};

const CalendarControls = ({
  country,
  state,
  onCountryChange,
  onStateChange,
  onLoadKlydos,
  klydosLoading,
  klydosError,
  klydosLoaded,
}: CalendarControlsProps) => {
  const activeCount = (country ? 1 : 0) + (state ? 1 : 0);

  return (
    <FilterBar
      activeCount={activeCount}
      defaultOpen
      quickActions={
        <LoadKlydosButton
          onLoadKlydos={onLoadKlydos}
          klydosLoading={klydosLoading}
          klydosError={klydosError}
          klydosLoaded={klydosLoaded}
          disabled={!country}
        />
      }
    >
      <DSBox sx={{ flex: "1 1 240px", maxWidth: 340 }}>
        <CountryDropdown initialCountry={country} onSelect={onCountryChange} />
      </DSBox>
      <DSBox sx={{ flex: "1 1 240px", maxWidth: 340 }}>
        <StateDropdown
          country={country}
          initialState={state}
          onSelect={onStateChange}
        />
      </DSBox>
    </FilterBar>
  );
};

export default CalendarControls;
